import Link from "next/link"
import Image from "next/legacy/image"
import { Routes, useParam } from "@blitzjs/next"
import { trpc } from "app/core/trpcClient"
import Logo from "public/SuperwallLogo.svg"
import React, { FC, PropsWithChildren, ReactNode, useContext } from "react"
import tw from "tailwind-styled-components"
import { UserGroup } from "./UserGroup"
import { BackButtonBehavior } from "./application/ApplicationLoader"
import { GlobalDataOptionsContext } from "app/insights/GlobalDataOptions"

export const HeaderWrapperBase = tw.div`
	w-full
	flex
  px-6
  flex-shrink-0
	justify-between
	items-center
`

export const HeaderWrapper = tw(HeaderWrapperBase)`
  border-b
  border-opacity-7
  border-white
  bg-grayscale-darker
  fixed
  t-0
  l-0
  r-0
  z-[11]
`

export const HeaderWrapperDark = tw(HeaderWrapperBase)`
dark:bg-grayscale-darkest
border-b border-opacity-7 border-white bg-grayscale-darkest
bg-opacity-40
`

export const HeaderContent = tw.div`
  relative
  flex
  flex-grow
  justify-between
  items-center
  ml-auto
  mr-auto
`

const HeaderGroup = tw.div`
  flex
  flex-row
  justify-center
  items-center
`

const HeaderLogoWrapper: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div
      className=""
      style={{
        position: "absolute",
        left: "calc(50% - 57px)",
        paddingTop: "5px",
        width: "114px",
      }}
    >
      {children}
    </div>
  )
}

export const HeaderButtonWrapper = tw.div`
rounded-lg
dark:bg-grayscale-light
flex
items-center
pl-3
pr-2
py-1
`

export interface HeaderProps {
  leftButtons?: React.ReactNode
  rightButtons?: React.ReactNode
  fullWidth?: boolean
  backButtonBehavior?: BackButtonBehavior
  backDestination?: string
  title?: ReactNode | string
}

export const Header: FC<HeaderProps> = ({
  leftButtons = <p></p>,
  rightButtons = <UserGroup />,
  fullWidth = false,
  title = undefined,
}) => {
  const applicationId = useParam("applicationId", "number")!
  const { data: application } = trpc.blitzMigration.applications.getApplication.useQuery(
    { id: applicationId },
    { suspense: false, enabled: !!applicationId }
  )
  const homeLink = applicationId ? `/applications/${applicationId}` : Routes.Home()

  const { environment } = useContext(GlobalDataOptionsContext)

  return (
    <>
      <HeaderWrapper style={{ height: "75px" }}>
        <HeaderContent className={fullWidth ? "" : "max-w-8xl"}>
          <HeaderGroup className="gap-4">{leftButtons}</HeaderGroup>
          <HeaderLogoWrapper>
            <Link passHref={true} href={homeLink}>
              <Image alt={"logo"} src={Logo} />
            </Link>
          </HeaderLogoWrapper>
          <HeaderGroup className="gap-4">{rightButtons}</HeaderGroup>
        </HeaderContent>
      </HeaderWrapper>
      {application && application.globallyDisabled ? (
        <HeaderWrapper style={{ height: "75px" }} className={`dark:bg-grayscale-darkest`}>
          <HeaderContent>{`Warning: Superwall disabled, check settings`}</HeaderContent>
        </HeaderWrapper>
      ) : null}
      {application && environment === "SANDBOX" ? (
        <HeaderWrapper style={{ height: "2px" }} className={`bg-orange-400`}></HeaderWrapper>
      ) : null}
      <div className="h-[75px]"></div>
    </>
  )
}
